import axiosInstance from "../utils/axios";

export const waterTankService = {
  getById: async (id) => {
    const { data } = await axiosInstance.get(`/water-tank/${id}`);
    return data;
  },
  verify: async (id, body) => {
    const { data } = await axiosInstance.patch(
      `/water-tank/${id}/verify`,
      body
    );
    return data;
  },
  reject: async (id, body) => {
    const { data } = await axiosInstance.patch(
      `/water-tank/${id}/reject`,
      body
    );
    return data;
  },
  getAllData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/water-tank/paginate`, {
      params,
    });
    return data;
  },
};
